<template>
  <div class=" section_sectionWrapper">
    <div class="module-story">
      <div class="title"></div>
      <div class="story-cont">

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',


  data() {
    return {

    }
  },
  methods: {
    handleIcon(item) {
      alert(item)
    }
  },
  watch: {


  }
}
</script>
<style lang="scss" scoped>
.module-story {
  position: relative;
  height: 100%;
  width: 100%;
  // width: 1920px;
  // height: 1080px;
  background-size: cover;

  background-image: url("../../assets/img/story/bg.png");

  .title {
    width: 402px;
    height: 117px;
    background-size: 100% 100%;
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../../assets/img/story/title.png");
  }

  .story-cont {
    width: 1078px;
    height: 724px;
    background-image: url("../../assets/img/story/cnt-world.png");
    background-size: 100% 100%;
    position: absolute;
    right: 330px;
    transform: translate(0, -60%);
    top: 60%;

  }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-story {
    .title {
      width: 321px !important;
      height: 94px !important;
    }

    .story-cont {
      width: 862px !important;
      height: 580px !important;
      right: 460px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/story.vue